import {apiLink} from "../../app/routes/api_link";
import {notifyBugsnag} from "../../app/utils/bugsnag/notify_bugsnag";
import {getRequest} from "../../app/utils/request_response_utils/request";
import {catch404} from "../../app/utils/request_response_utils/response_error";

type PrivacyPolicyResponse = {
    privacy_policy_url: string | null;
    privacy_policy_file: string | null;
};

/**
 * fetch privacy policy links for offer
 * @param offerId : string
 * @constructor
 */
export const OfferPrivacyPolicyFetch = (offerId?: string) => async (): Promise<PrivacyPolicyResponse | null> => {
    if (!offerId) {
        return null;
    }
    const url = apiLink.offers.privacyPolicy({})({offerId: offerId});
    return getRequest({}, url)
        .catch(
            catch404(() => {
                // we expect 404 on private offers
                return null;
            })
        )
        .catch((e) => {
            notifyBugsnag({message: `Error while fetching privacy policy for offer ${offerId}`}, `Error while fetching privacy policy for offer ${offerId}`, e);
            return null;
        });
};
